import React from 'react';

/**
 * EligibilityToggle - A polished toggle for "Counts toward eligibility"
 * 
 * Usage:
 *   <EligibilityToggle
 *     checked={newItem.countsForEligibility || false}
 *     onChange={(val) => setNewItem({ ...newItem, countsForEligibility: val })}
 *   />
 */
const EligibilityToggle = ({ checked, onChange }) => {
  return (
    <div style={styles.wrapper}>
      <div style={styles.card(checked)}>
        <div style={styles.left}>
          <div style={styles.iconCircle(checked)}>
            <span style={styles.icon}>{checked ? '✓' : '🛡️'}</span>
          </div>
          <div style={styles.textBlock}>
            <span style={styles.label}>Counts toward eligibility</span>
            <span style={styles.hint(checked)}>
              {checked
                ? 'Students must submit on time to stay eligible'
                : 'Not tracked for money-back guarantee'}
            </span>
          </div>
        </div>
        <button
          type="button"
          role="switch"
          aria-checked={checked}
          onClick={() => onChange(!checked)}
          style={styles.track(checked)}
        >
          <span style={styles.knob(checked)} />
        </button>
      </div>
    </div>
  );
};

const styles = {
  wrapper: {
    marginTop: '16px',
  },
  card: (on) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '16px',
    padding: '14px 18px',
    borderRadius: '12px',
    border: `1.5px solid ${on ? '#10b981' : '#e5e7eb'}`,
    background: on
      ? 'linear-gradient(135deg, #ecfdf5 0%, #f0fdf4 100%)'
      : '#fafafa',
    transition: 'all 0.25s ease',
    cursor: 'pointer',
  }),
  left: {
    display: 'flex',
    alignItems: 'center',
    gap: '14px',
    flex: 1,
    minWidth: 0,
  },
  iconCircle: (on) => ({
    width: '38px',
    height: '38px',
    borderRadius: '10px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: on ? '#10b981' : '#f3f4f6',
    color: on ? '#fff' : '#9ca3af',
    fontSize: '16px',
    fontWeight: '700',
    flexShrink: 0,
    transition: 'all 0.25s ease',
  }),
  icon: {
    lineHeight: 1,
  },
  textBlock: {
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',
    minWidth: 0,
  },
  label: {
    fontSize: '14px',
    fontWeight: '600',
    color: '#1f2937',
    lineHeight: '1.3',
  },
  hint: (on) => ({
    fontSize: '12px',
    color: on ? '#059669' : '#9ca3af',
    lineHeight: '1.3',
    transition: 'color 0.25s ease',
  }),
  // Toggle track
  track: (on) => ({
    position: 'relative',
    width: '52px',
    height: '28px',
    borderRadius: '14px',
    border: 'none',
    padding: 0,
    cursor: 'pointer',
    flexShrink: 0,
    background: on
      ? 'linear-gradient(135deg, #10b981, #059669)'
      : '#d1d5db',
    transition: 'background 0.25s ease',
    outline: 'none',
    boxShadow: on
      ? '0 0 0 3px rgba(16, 185, 129, 0.15)'
      : 'inset 0 1px 3px rgba(0,0,0,0.1)',
  }),
  // Toggle knob
  knob: (on) => ({
    position: 'absolute',
    top: '3px',
    left: on ? '27px' : '3px',
    width: '22px',
    height: '22px',
    borderRadius: '11px',
    background: '#fff',
    boxShadow: '0 1px 4px rgba(0,0,0,0.18)',
    transition: 'left 0.25s cubic-bezier(0.34, 1.56, 0.64, 1)',
  }),
};

export default EligibilityToggle;
